import React from 'react';

/**
 * Выделяет совпадающие части текста жирным шрифтом
 * @param text - Полный текст
 * @param query - Поисковый запрос
 * @returns JSX с выделенными совпадениями
 */
export const highlightMatch = (text: string, query: string): React.ReactNode => {
  if (!query.trim()) {
    return <span>{text}</span>;
  }

  const lowerText = text.toLowerCase();
  const lowerQuery = query.toLowerCase();
  const index = lowerText.indexOf(lowerQuery);

  if (index === -1) {
    return <span>{text}</span>;
  }

  const before = text.substring(0, index);
  const match = text.substring(index, index + query.length);
  const after = text.substring(index + query.length);

  return (
    <span>
      {before}
      <span className="font-bold text-blue-700">{match}</span>
      {after}
    </span>
  );
};

